import axios from 'axios';
import { stringify } from 'qs';
import dom from '@/lib/core/dom';
import gon from '@/lib/core/gon';
import { baseUrl } from '@/lib/config';

const api = axios.create({
  withCredentials: true,
  paramsSerializer: function (params) {
    return stringify(params, { arrayFormat: 'brackets' });
  },
  headers: {
    Accept: 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 请求不为 GET 时添加 CSRF Token
    if (config.method !== 'get') {
      config.headers['X-CSRF-Token'] = dom.getMetaContent('csrf-token');
    }

    if (gon.debug && gon.build_sha) {
      config.headers['Debug'] = gon.build_sha;
    }

    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    config.url = `${baseUrl}${config.url}`;

    return config;
  },
  (_err) => {
    return {
      error: { success: false, code: '41800', message: '请求时网络异常，请重试' },
      status: 418,
    };
  },
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return {
      response: response.data,
      status: response.status,
    };
  },
  (error) => {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error.response) {
      return { error: error.response.data, status: error.response.status };
    }

    return {
      error: { success: false, code: '41801', message: '客户端发生异常，请重试' },
      status: 418,
    };
  },
);

export default api;
